import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { SizeFitHintAndGuide } from '@/app/[abTest]/[locale]/(spreadshirt)/cyo/assortment/detail/components/SizeSelectors';
import { SizeButton } from '@/components/Sizes/SizeButton';
import { ClientSellableAndProductType } from '../utility/pdpGroups';
type GroupedSellableProps = {
  sellableGroup: ClientSellableAndProductType[];
  selectedSellable: Sellable;
  productType: ClientProductType;
  onSellableSelection: (sellableAndProductType: ClientSellableAndProductType) => void;
  platform: Platform;
  error?: boolean;
};
export const GroupedSellableSelector = t0 => {
  const $ = _c(32);
  const {
    productType,
    sellableGroup,
    selectedSellable,
    onSellableSelection,
    platform,
    error
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== sellableGroup) {
    t1 = sellableGroup.map(_temp);
    $[0] = sellableGroup;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== productType || $[3] !== t1) {
    t2 = {
      ...productType,
      sizes: t1
    };
    $[2] = productType;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sizeGuideProductType = t2;
  let t3;
  if ($[5] !== platform || $[6] !== sizeGuideProductType) {
    t3 = <SizeFitHintAndGuide productType={sizeGuideProductType} platform={platform} isSellableGroup={true} />;
    $[5] = platform;
    $[6] = sizeGuideProductType;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = error && "animate-shake";
  let t5;
  if ($[8] !== t4) {
    t5 = clsx(t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("cyoAssortmentDetailPage.selectSize");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <legend className="sr-only">{t6}</legend>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== error || $[15] !== onSellableSelection || $[16] !== selectedSellable || $[17] !== sellableGroup) {
    let t9;
    if ($[19] !== error || $[20] !== onSellableSelection || $[21] !== selectedSellable) {
      t9 = sellableAndProductType_0 => {
        const inStock = sellableAndProductType_0.productType.stockStates.some(_temp2);
        return <SizeButton key={sellableAndProductType_0.sellable.sellableId} onClick={() => onSellableSelection(sellableAndProductType_0)} selected={sellableAndProductType_0.sellable.sellableId === selectedSellable.sellableId} disabled={!inStock} error={error}>{sellableAndProductType_0.productType.name}</SizeButton>;
      };
      $[19] = error;
      $[20] = onSellableSelection;
      $[21] = selectedSellable;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    t8 = sellableGroup.map(t9);
    $[14] = error;
    $[15] = onSellableSelection;
    $[16] = selectedSellable;
    $[17] = sellableGroup;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[23] !== t8) {
    t9 = <div className="flex flex-wrap gap-2">{t8}</div>;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t5 || $[26] !== t7 || $[27] !== t9) {
    t10 = <fieldset className={t5}>{t7}{t9}</fieldset>;
    $[25] = t5;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t3) {
    t11 = <div className="flex flex-col gap-3">{t3}{t10}</div>;
    $[29] = t10;
    $[30] = t3;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
function _temp(sellableAndProductType) {
  return {
    id: `${sellableAndProductType.productType.sizes[0]?.id}-${sellableAndProductType.productType.id}`,
    name: sellableAndProductType.productType.name,
    measures: sellableAndProductType.productType.sizes[0]?.measures || [],
    weight: sellableAndProductType.productType.sizes[0]?.weight || 0
  };
}
function _temp2(stockState) {
  return stockState.available;
}